import { render, staticRenderFns } from "./CreateLaw.vue?vue&type=template&id=3d22cddd"
import script from "./CreateLaw.vue?vue&type=script&lang=js"
export * from "./CreateLaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports